// 💾 src/pages/public/Home.tsx
import { Helmet } from "react-helmet-async"
import { useTranslation } from "react-i18next"
import HeroSection from "../../components/home/HeroSection"
import MarketTicker from "../../components/home/MarketTicker"
import FeaturesSection from "../../components/home/FeaturesSection"
import HowItWorks from "../../components/home/HowItWorks"
import CallToAction from "../../components/home/CallToAction"
import Stats from "../../components/home/Stats"
import TrendingTokensSection from "../../components/home/TrendingTokens.Section"

const Home = () => {
  const { t } = useTranslation()

  return (
    <>
      <Helmet>
        <title>{t("home.title")}</title>
      </Helmet>
      <main className="home">
        <HeroSection />
        <TrendingTokensSection />
        <HowItWorks />
        <Stats />
        
        <CallToAction />
      </main>
    </>
  )
}

export default Home
